/**
 * @description Main class that handles the project form.
 */
import { loadDataAVI } from "../../common/constants/functions/loadDataAVI";
import { hideModal, showModal } from "../../common/constants/functions/modalFunctions";
import { ValidateFields } from "./ValidateFields";
class GetProjectForm {
    constructor(formState) {
        this.formState = formState;
        this.contextComponent = '';
        this.urlUtm = '';
        this.fieldsIncome = '';
        this.productOfert = 1;
        this.eventCalculator = '';
        this.referrer = 'portal';
        this.ID = 0;
        this.valueFields = 6;
        this.optionsProductOfert = '';
        this.idForm = "#form-";
        this.typologyType = '';
        this.fair = '';
        this.requireIncome = '';
        this.valor_vivienda_credito = '';
        this.getDataForm = this.getDataForm.bind(this); // Bind to use the correct context
    }
    /**
     * @description Method that assigns a value to the `productOfert` property
     * @param {string} optionsProduct - The product option received as a string.
     * It can be one of the following values: 'portal', 'sostenimiento', 'feria',
     * 'membresia', and their mobile variants with '-mb'.
     */
    getProductOfert(optionsProduct) {
        // We use a switch to check the product option and assign the corresponding value
        var _a, _b;
        const productMap = {
            'portal': { productOfert: 1 },
            'sostenimiento': { productOfert: 2 },
            'feria': { productOfert: 3 },
            'membresia': { productOfert: 6 },
            'portalmb': { productOfert: 1, mobileSuffix: '-mobile' },
            'sostenimientomb': { productOfert: 2, mobileSuffix: '-mobile' },
            'feriamb': { productOfert: 3, mobileSuffix: '-mobile' },
            'membresiamb': { productOfert: 6, mobileSuffix: '-mobile' }
        };
        this.productOfert = ((_a = productMap[optionsProduct]) === null || _a === void 0 ? void 0 : _a.productOfert) || 1;
        this.referrer = ((_b = productMap[optionsProduct]) === null || _b === void 0 ? void 0 : _b.mobileSuffix) ? `${this.referrer}${productMap[optionsProduct].mobileSuffix}` : this.referrer;
        this.formState.manageState('productOfert', this.productOfert);
    }
    /**
     * @description Method that assigns a value to the `origen` property
     * @param {string} origen - The origen received as a string.
     * It can be one of the following values: 'Google', 'Facebook'.
     */
    getOrigen(origen) {
        // We use a switch to check the origen and assign the corresponding value
        const origenMap = {
            'google_search': 'Google',
            'facebook': 'Facebook'
        };
        this.formState.manageState('origen', origenMap[origen]);
    }
    /**
     * @description Retrieves and configures project ads based on content type.
     * @param {number} idProject - The project ID.
     * @param {string} contentType - The content type (e.g., "ads-blog", "pop-up").
     */
    getProjectAds(idProject, contentType) {
        if (['ads-blog', 'pop-up'].includes(contentType) || contentType.startsWith('zone')) {
            this.handleAdsContent(contentType, idProject);
        }
        else if (contentType === 'gallery') {
            this.handleGalleryContent(idProject);
        }
    }
    handleAdsContent(contentType, idProject) {
        var _a;
        this.formState.manageState('origen', 'Display');
        (_a = document.querySelector("#familyIncomeBanner")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
        if (contentType.startsWith('zone')) {
            this.setupAdsContent(contentType);
        }
        if (['ads-blog'].includes(contentType)) {
            this.setupAdsContent(contentType);
            this.ID ? showModal('modalContacto') : hideModal('modalContacto');
            setTimeout(() => this.ID ? showModal('modalContacto') : hideModal('modalContacto'), 1000);
        }
        if (contentType === 'pop-up') {
            this.setupPopUpContent();
            this.showPopUpModal(idProject);
        }
        // Manage family income options
        this.manageFamilyIncome();
        // Set product offer if available
        if (this.optionsProductOfert && this.referrer) {
            this.getProductOfert(this.optionsProductOfert);
        }
    }
    setupAdsContent(contentType) {
        var _a, _b;
        const element = document.querySelector(`#${contentType} a`);
        if (element) {
            this.ID = parseInt(element.getAttribute('dataproject_href') || '0');
            this.optionsProductOfert = element.getAttribute('dataproject_product') || 'sostenimiento';
            this.fieldsIncome = element.getAttribute('dataproject_text') || '';
            (_a = document.getElementById("value-price-form-home")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
            (_b = document.getElementById("value-budget-form-home")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            this.referrer = "banner-ads-resultados";
        }
    }
    setupPopUpContent() {
        var _a;
        const popUpElement = document.querySelector('.pop-up-ad a');
        if (popUpElement) {
            this.optionsProductOfert = popUpElement.getAttribute('dataproject_product') || 'portal';
            this.fieldsIncome = popUpElement.getAttribute('dataproject_text') || '';
            this.urlUtm = popUpElement.getAttribute('dataproject_url') || '';
            sessionStorage.setItem('urlUtm', this.urlUtm);
            this.referrer = "pop-up-formulario";
            this.contextComponent = 'Pop up';
        }
        (_a = document.querySelector('.js-content-info-form-popup')) === null || _a === void 0 ? void 0 : _a.setAttribute("id", "form-popup-" + this.ID);
    }
    showPopUpModal(idProject) {
        const iframe = document.querySelector('.pop-up-ad iframe');
        if (iframe) {
            if (idProject) {
                showModal('modalPopup');
            }
            else {
                this.hidePopUpLink(iframe);
            }
        }
    }
    hidePopUpLink(iframe) {
        const popUpLink = document.querySelector('.pop-up-ad a');
        if (popUpLink) {
            popUpLink.setAttribute("data-bs-toggle", "");
            popUpLink.setAttribute("data-bs-target", "");
        }
        showModal('modalPopup');
        iframe.style.zIndex = '0';
    }
    manageFamilyIncome() {
        var _a;
        if (this.fieldsIncome) {
            this.fieldsIncome = this.fieldsIncome.split('-').join(' ').replace('%2C', ',');
            let arrayIncome = this.fieldsIncome.split(',');
            let optionsIncome = '<option selected value="" disabled>Ingresos familiares</option>';
            arrayIncome.forEach((element, index) => {
                let option = element.split('-').join(' ');
                optionsIncome += `<option value='${index === 0 ? 'Inferior a' : 'Superior a'} ${option} millones'>${index === 0 ? 'Inferior a' : 'Superior a'} ${option} millones</option>`;
            });
            document.getElementById('familyIncomeBanner').innerHTML = optionsIncome;
            (_a = this.form.querySelector("#familyIncomeBanner")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
        }
    }
    handleGalleryContent(idProject) {
        this.formState.manageState('origen', 'website');
        let habitarInvertir = Array.from(document.querySelectorAll('#form-gallery-' + idProject + " input[name='habitar_invertir']"));
        habitarInvertir.forEach(item => {
            const inputItem = item;
            if (inputItem.checked) {
                inputItem.checked = false;
            }
        });
    }
    /**
     * @description Clears the form fields when the type changes (e.g., from cards to buttons).
     */
    getProjectCards() {
        var _a, _b, _c;
        this.formState.manageState('origen', 'website');
        this.formState.manageState('contextComponent', 'cards');
        (_a = document.getElementById("value-price-form-home")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
        (_b = document.getElementById("value-budget-form-home")) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
        (_c = this.form.querySelector("#familyIncomeBanner")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
    }
    /**
    * Method to get and configure the form data.
    * @param {string} sectionType - The type of section.
    * @param {number} idProject - The project ID.
    * @returns {void}
    */
    getDataForm(sectionType, idProject) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        this.ID = idProject || Number((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.getAttribute('value'));
        this.formState.manageState('typologyId', this.ID);
        (_b = document.querySelector('.js-content-info-form')) === null || _b === void 0 ? void 0 : _b.setAttribute("id", "form-" + this.ID);
        this.getIdForm(sectionType);
        let dataAVI = new loadDataAVI(this.formState);
        let isAVI = dataAVI.isAVI();
        if (isAVI) {
            const target = event === null || event === void 0 ? void 0 : event.currentTarget;
            const container = target.closest('.js-card-project');
            if (target.id != 'heart-button') {
                target.innerHTML = `
                <span class="sending-message d-flex" id="sending-mss-avi">
                    <div class="lds-dual-ring"></div>
                    Enviando			    
                </span>`;
            }
            else {
                const animation = container.querySelector('.like-animation');
                animation.classList.add('animate');
            }
            target.classList.add('target');
        }
        this.form = document.querySelector(this.idForm + this.ID);
        this.referrer = 'portal';
        this.fair = ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.getAttribute('fair')) || '';
        let fairBuilder = ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.getAttribute('fairBuilder')) || '';
        let fairWhiteBrand = ((_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.getAttribute('fairWhiteBrand')) || '';
        if (this.fair === '1') {
            this.formState.manageState('productOfert', 3);
        }
        else if (fairBuilder === '1') {
            this.formState.manageState('productOfert', 7);
        }
        else if (fairWhiteBrand === '1') {
            this.formState.manageState('productOfert', 8);
        }
        else {
            this.formState.manageState('productOfert', 1);
        }
        this.eventCalculator = ((_f = document.querySelector('[data-btn-cotizar], [id]')) === null || _f === void 0 ? void 0 : _f.getAttribute('id')) ||
            ((_g = document.querySelector('[data-btn-cotizar], [id]')) === null || _g === void 0 ? void 0 : _g.getAttribute('data-btn-cotizar')) || '';
        this.formState.manageState('eventCalculator', this.eventCalculator);
        if (sectionType === 'cards' || sectionType === 'buttons') {
            this.getProjectCards();
        }
        else {
            this.getProjectAds(idProject, sectionType);
        }
        let hideInputs = (_h = this.form) === null || _h === void 0 ? void 0 : _h.querySelectorAll('.field-no-vis, .mortgage-input, .mortgage-input input, .mortgage-label');
        if (hideInputs) {
            hideInputs.forEach(input => {
                input.classList.add("d-none");
            });
        }
        this.requireIncome = ((_j = event === null || event === void 0 ? void 0 : event.target) === null || _j === void 0 ? void 0 : _j.getAttribute('data-income')) || '';
        this.valor_vivienda_credito = ((_k = event === null || event === void 0 ? void 0 : event.target) === null || _k === void 0 ? void 0 : _k.getAttribute('typology-price')) ? (_l = event === null || event === void 0 ? void 0 : event.target) === null || _l === void 0 ? void 0 : _l.getAttribute('typology-price').trim().replace(/\./g, '') : '0';
        this.typologyType = ((_m = event === null || event === void 0 ? void 0 : event.target) === null || _m === void 0 ? void 0 : _m.getAttribute('typology-type')) || '';
        let typologyIncome = ((_o = event === null || event === void 0 ? void 0 : event.target) === null || _o === void 0 ? void 0 : _o.getAttribute('typology-income'));
        let typologyProperty = ((_p = event === null || event === void 0 ? void 0 : event.target) === null || _p === void 0 ? void 0 : _p.getAttribute('typology-property'));
        let typologyName = ((_q = event === null || event === void 0 ? void 0 : event.target) === null || _q === void 0 ? void 0 : _q.getAttribute('typology-name'));
        let creditType = ((_r = event === null || event === void 0 ? void 0 : event.target) === null || _r === void 0 ? void 0 : _r.getAttribute('data-credit-type')) || '';
        let builderNumber = ((_s = event === null || event === void 0 ? void 0 : event.target) === null || _s === void 0 ? void 0 : _s.getAttribute('builder-number'));
        let builderName = ((_t = event === null || event === void 0 ? void 0 : event.target) === null || _t === void 0 ? void 0 : _t.getAttribute('builder-name'));
        let postSimulator = ((_u = event === null || event === void 0 ? void 0 : event.target) === null || _u === void 0 ? void 0 : _u.getAttribute('data-post-simulator')) || '';
        let redirect = ((_v = event === null || event === void 0 ? void 0 : event.target) === null || _v === void 0 ? void 0 : _v.getAttribute('data-redirect'));
        let schedulingUrl = ((_w = event === null || event === void 0 ? void 0 : event.target) === null || _w === void 0 ? void 0 : _w.getAttribute('data-scheduling-url'));
        this.formState.manageState('builderNumber', builderNumber);
        this.formState.manageState('builderName', builderName);
        this.formState.manageState('projectRedirect', redirect);
        this.formState.manageState('redirectSimulator', postSimulator);
        this.formState.manageState('schedulingUrl', schedulingUrl);
        this.formState.manageState('formName', this.idForm + this.ID);
        this.formState.manageState('referrer', this.referrer);
        this.formState.manageState('typologyPrice', this.valor_vivienda_credito);
        this.formState.manageState('typologyType', this.typologyType);
        this.formState.manageState('creditType', creditType);
        this.formState.manageState('typologyIncome', typologyIncome);
        this.formState.manageState('typologyProperty', typologyProperty);
        this.formState.manageState('typologyName', typologyName);
        this.formState.manageState('valueFields', this.valueFields);
        this.formState.manageState('openCalculator', '');
        if (this.form) {
            (_x = this.form.querySelector('#load-send-form')) === null || _x === void 0 ? void 0 : _x.classList.remove("d-flex");
            (_y = this.form.querySelector('.js-confirmation-mess')) === null || _y === void 0 ? void 0 : _y.classList.remove("d-flex");
            (_z = this.form.querySelector('#fields-form')) === null || _z === void 0 ? void 0 : _z.classList.remove("d-none");
        }
        this.setModal();
        if (document.querySelector(this.idForm + this.ID + ' #btn-form')) {
            (_0 = document.querySelector(this.idForm + this.ID + ' #sending-mss')) === null || _0 === void 0 ? void 0 : _0.classList.add("d-none");
            (_1 = document.querySelector(this.idForm + this.ID + ' #btn-form .js-message')) === null || _1 === void 0 ? void 0 : _1.classList.remove("d-none");
            (_2 = document.querySelector(this.idForm + this.ID + ' #btn-form .js-message')) === null || _2 === void 0 ? void 0 : _2.classList.add("d-block");
            document.querySelector('input[name="checkboxForm"]').checked = false;
        }
        if (document.querySelector(this.idForm + this.ID + ' #btn-form-image')) {
            (_3 = document.querySelector(this.idForm + this.ID + ' #sending-mss-image')) === null || _3 === void 0 ? void 0 : _3.classList.add("d-none");
            (_4 = document.querySelector(this.idForm + this.ID + ' #btn-form-image .js-message')) === null || _4 === void 0 ? void 0 : _4.classList.remove("d-none");
            (_5 = document.querySelector(this.idForm + this.ID + ' #btn-form-image .js-message')) === null || _5 === void 0 ? void 0 : _5.classList.add("d-block");
            document.querySelector('input[name="checkboxForm"]').checked = false;
        }
    }
    /**
     * Method to determine the form type depending on the content type.
     * @param {string} contenType - The content type, which can be 'gallery', 'typology_form', 'ads-blog', among others.
     * @returns {void}
     */
    getIdForm(contenType) {
        // Assign the form ID depending on the content type
        if (contenType == 'gallery') {
            this.idForm = '#form-gallery-';
        }
        else if (contenType == 'typology_form') {
            const isMobile = window.innerWidth < 1000;
            this.idForm = isMobile ? '#form-typology-mobile-' : '#form-typology-';
        }
        else if (contenType == 'blueprint') {
            this.idForm = "#form-blueprint-";
        }
        else if (contenType == 'ads-blog') {
            this.idForm = '#form-blog-0';
            this.formState.manageState('productOfert', 2);
            this.formState.manageState('origen', 'Blog');
        }
        else if (contenType == 'pop-up') {
            this.idForm = '#form-popup-';
        }
        else {
            this.idForm = '#form-';
        }
    }
    calculatorModal() {
        var _a, _b;
        const calculatorBtn = document.querySelector("#Btn_calculator_option_credit");
        const calculatorBtnSubsidy = document.querySelector("#Btn_calculator_option_subsidy");
        const typologyCreditType = this.formState.manageState('creditType');
        if (((this.typologyType == '11660' || this.typologyType == '11801') && (typologyCreditType != 'financiamiento')) || typologyCreditType == 'subsidio') {
            (_a = document.getElementById('Btn_lqn_subsidy')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
            document.getElementById('question_simulator').innerHTML = '¿Quieres realizar una simulación?';
            calculatorBtn === null || calculatorBtn === void 0 ? void 0 : calculatorBtn.classList.remove('d-none');
            calculatorBtnSubsidy === null || calculatorBtnSubsidy === void 0 ? void 0 : calculatorBtnSubsidy.classList.remove('d-none');
        }
        else {
            (_b = document.getElementById('Btn_lqn_subsidy')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            document.getElementById('question_simulator').innerHTML = '¿Quieres simular tu Crédito?';
            calculatorBtn === null || calculatorBtn === void 0 ? void 0 : calculatorBtn.classList.add('d-none');
            calculatorBtnSubsidy === null || calculatorBtnSubsidy === void 0 ? void 0 : calculatorBtnSubsidy.classList.add('d-none');
        }
    }
    /**
     * Configures the contact modal, modifying DOM elements as needed.
     * @returns {void}
     */
    setModal() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let modalContactForm = document.querySelector('.modal-content.modal-content-form.modal-contact-form');
        modalContactForm.style.maxHeight = '96vh';
        modalContactForm.style.width = '100%';
        modalContactForm.style.overflow = 'auto';
        modalContactForm.style.minHeight = '470px';
        let headerBuilderLogo = '';
        let builderName = '';
        let postSubmitAction = '';
        if (((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.getAttribute('data-builder-logo')) && ((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.getAttribute('builder-name'))) {
            headerBuilderLogo = ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.getAttribute('data-builder-logo')) || '';
            builderName = ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.getAttribute('builder-name')) || '';
        }
        if ((_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.getAttribute('data-post-action')) {
            postSubmitAction = ((_f = event === null || event === void 0 ? void 0 : event.target) === null || _f === void 0 ? void 0 : _f.getAttribute('data-post-action')) || '';
        }
        let subtitleModal = document.querySelector(this.idForm + this.ID + " #modal-header-with-image #subtitle-modal-form");
        let submitCallButton = document.querySelector(this.idForm + this.ID + " .js-message--call");
        let submitButtonContainer = document.querySelector(this.idForm + this.ID + " #send-form");
        let submitCallButtonContainer = document.querySelector(this.idForm + this.ID + " #send-form-call");
        let submitWhatButtonContainer = document.querySelector(this.idForm + this.ID + " #send-form-whatsapp");
        let headerImage = document.querySelector(this.idForm + this.ID + " #modal-header-image");
        if (document.querySelector(this.idForm + this.ID + " #modal-header-with-image")) {
            (_g = document.querySelector(this.idForm + this.ID + " #modal-header-with-image")) === null || _g === void 0 ? void 0 : _g.classList.add("modal-header--image");
        }
        if (headerImage && headerBuilderLogo) {
            headerImage.classList.add("modal-header--image__img");
            headerImage.classList.remove("d-none");
        }
        else {
            headerImage === null || headerImage === void 0 ? void 0 : headerImage.classList.add("d-none");
        }
        if (submitCallButton) {
            submitCallButton.setAttribute("builder-number", ((_h = event === null || event === void 0 ? void 0 : event.target) === null || _h === void 0 ? void 0 : _h.getAttribute('builder-number')) || '');
        }
        headerImage ? headerImage.src = headerBuilderLogo : '/themes/custom/ev_theme/assets/images/iconos_resultados_cards/send-mail-icon.png';
        headerBuilderLogo ? headerImage === null || headerImage === void 0 ? void 0 : headerImage.classList.add('logo-builder') : headerImage === null || headerImage === void 0 ? void 0 : headerImage.classList.remove('logo-builder');
        builderName && subtitleModal ? subtitleModal.innerHTML = `<span class="builder-name" id="builderName">${builderName}</span> se comunicará contigo` : '';
        if (submitButtonContainer) {
            submitButtonContainer.setAttribute("data-post-action", postSubmitAction);
        }
        if (submitCallButtonContainer) {
            submitCallButtonContainer.setAttribute("data-post-action", postSubmitAction);
        }
        if (submitWhatButtonContainer) {
            submitWhatButtonContainer.setAttribute("data-post-action", postSubmitAction);
        }
        this.calculatorModal();
        (_j = document.querySelector('.checkbox-cards')) === null || _j === void 0 ? void 0 : _j.setAttribute("valueId", this.ID.toString());
    }
    /**
     * Define city code options, modifying DOM elements as needed.
     * @returns {void}
     */
    setCountryCode() {
        const phoneCountryCodes = [
            { value: '+93', label: 'Afganistán (+93)' },
            { value: '+355', label: 'Albania (+355)' },
            { value: '+49', label: 'Alemania (+49)' },
            { value: '+213', label: 'Algeria (+213)' },
            { value: '+376', label: 'Andorra (+376)' },
            { value: '+244', label: 'Angola (+244)' },
            { value: '+1 264', label: 'Anguila (+1 264)' },
            { value: '+672', label: 'Antártida (+672)' },
            { value: '+1 268', label: 'Antigua y Barbuda (+1 268)' },
            { value: '+966', label: 'Arabia Saudita (+966)' },
            { value: '+54', label: 'Argentina (+54)' },
            { value: '+374', label: 'Armenia (+374)' },
            { value: '+297', label: 'Aruba (+297)' },
            { value: '+61', label: 'Australia (+61)' },
            { value: '+43', label: 'Austria (+43)' },
            { value: '+994', label: 'Azerbayán (+994)' },
            { value: '+1 242', label: 'Bahamas (+1 242)' },
            { value: '+973', label: 'Bahrein (+973)' },
            { value: '+880', label: 'Bangladesh (+880)' },
            { value: '+1 246', label: 'Barbados (+1 246)' },
            { value: '+32', label: 'Bélgica (+32)' },
            { value: '+501', label: 'Belice (+501)' },
            { value: '+229', label: 'Benín (+229)' },
            { value: '+975', label: 'Bhután (+975)' },
            { value: '+375', label: 'Bielorrusia (+375)' },
            { value: '+95', label: 'Birmania (+95)' },
            { value: '+591', label: 'Bolivia (+591)' },
            { value: '+599', label: 'Bonaire (+599)' },
            { value: '+387', label: 'Bosnia y Herzegovina (+387)' },
            { value: '+267', label: 'Botsuana (+267)' },
            { value: '+55', label: 'Brasil (+55)' },
            { value: '+673', label: 'Brunéi (+673)' },
            { value: '+359', label: 'Bulgaria (+359)' },
            { value: '+226', label: 'Burkina Faso (+226)' },
            { value: '+257', label: 'Burundi (+257)' },
            { value: '+238', label: 'Cabo Verde (+238)' },
            { value: '+855', label: 'Camboya (+855)' },
            { value: '+237', label: 'Camerún (+237)' },
            { value: '+1', label: 'Canadá (+1)' },
            { value: '+235', label: 'Chad (+235)' },
            { value: '+56', label: 'Chile (+56)' },
            { value: '+86', label: 'China (+86)' },
            { value: '+357', label: 'Chipre (+357)' },
            { value: '+39', label: 'Ciudad del Vaticano (+39)' },
            { value: '+269', label: 'Comoras (+269)' },
            { value: '+242', label: 'República del Congo (+242)' },
            { value: '+243', label: 'República Democrática del Congo (+243)' },
            { value: '+57', label: 'Colombia (+57)' },
            { value: '+850', label: 'Corea del Norte (+850)' },
            { value: '+82', label: 'Corea del Sur (+82)' },
            { value: '+225', label: 'Costa de Marfil (+225)' },
            { value: '+506', label: 'Costa Rica (+506)' },
            { value: '+385', label: 'Croacia (+385)' },
            { value: '+53', label: 'Cuba (+53)' },
            { value: '+599', label: 'Curazao (+599)' },
            { value: '+45', label: 'Dinamarca (+45)' },
            { value: '+1 767', label: 'Dominica (+1 767)' },
            { value: '+593', label: 'Ecuador (+593)' },
            { value: '+20', label: 'Egipto (+20)' },
            { value: '+503', label: 'El Salvador (+503)' },
            { value: '+971', label: 'Emiratos Árabes Unidos (+971)' },
            { value: '+291', label: 'Eritrea (+291)' },
            { value: '+421', label: 'Eslovaquia (+421)' },
            { value: '+386', label: 'Eslovenia (+386)' },
            { value: '+34', label: 'España (+34)' },
            { value: '+1', label: 'Estados Unidos de América (+1)' },
            { value: '+372', label: 'Estonia (+372)' },
            { value: '+251', label: 'Etiopía (+251)' },
            { value: '+63', label: 'Filipinas (+63)' },
            { value: '+358', label: 'Finlandia (+358)' },
            { value: '+679', label: 'Fiyi (+679)' },
            { value: '+33', label: 'Francia (+33)' },
            { value: '+241', label: 'Gabón (+241)' },
            { value: '+220', label: 'Gambia (+220)' },
            { value: '+995', label: 'Georgia (+995)' },
            { value: '+233', label: 'Ghana (+233)' },
            { value: '+350', label: 'Gibraltar (+350)' },
            { value: '+1 473', label: 'Granada (+1 473)' },
            { value: '+30', label: 'Grecia (+30)' },
            { value: '+299', label: 'Groenlandia (+299)' },
            { value: '+590', label: 'Guadalupe (+590)' },
            { value: '+1 671', label: 'Guam (+1 671)' },
            { value: '+502', label: 'Guatemala (+502)' },
            { value: '+594', label: 'Guayana Francesa (+594)' },
            { value: '+44', label: 'Guernsey (+44)' },
            { value: '+224', label: 'Guinea (+224)' },
            { value: '+240', label: 'Guinea Ecuatorial (+240)' },
            { value: '+245', label: 'Guinea-Bissau (+245)' },
            { value: '+592', label: 'Guyana (+592)' },
            { value: '+509', label: 'Haití (+509)' },
            { value: '+504', label: 'Honduras (+504)' },
            { value: '+852', label: 'Hong kong (+852)' },
            { value: '+36', label: 'Hungría (+36)' },
            { value: '+91', label: 'India (+91)' },
            { value: '+62', label: 'Indonesia (+62)' },
            { value: '+964', label: 'Irak (+964)' },
            { value: '+98', label: 'Irán (+98)' },
            { value: '+353', label: 'Irlanda (+353)' },
            { value: '+55', label: 'Isla Bouvet (+55)' },
            { value: '+44', label: 'Isla de Man (+44)' },
            { value: '+61', label: 'Isla de Navidad (+61)' },
            { value: '+672', label: 'Isla Norfolk (+672)' },
            { value: '+354', label: 'Islandia (+354)' },
            { value: '+1 441', label: 'Islas Bermudas (+1 441)' },
            { value: '+1 345', label: 'Islas Caimán (+1 345)' },
            { value: '+672', label: 'Islas Cocos (Keeling) (+672)' },
            { value: '+682', label: 'Islas Cook (+682)' },
            { value: '+358', label: 'Islas de Åland (+358)' },
            { value: '+298', label: 'Islas Feroe (+298)' },
            { value: '+500', label: 'Islas Georgias del Sur y Sandwich del Sur (+500)' },
            { value: '+672', label: 'Islas Heard y McDonald (+672)' },
            { value: '+960', label: 'Islas Maldivas (+960)' },
            { value: '+500', label: 'Islas Malvinas (+500)' },
            { value: '+1 670', label: 'Islas Marianas del Norte (+1 670)' },
            { value: '+692', label: 'Islas Marshall (+692)' },
            { value: '+64', label: 'Islas Pitcairn (+64)' },
            { value: '+677', label: 'Islas Salomón (+677)' },
            { value: '+1 649', label: 'Islas Turcas y Caicos (+1 649)' },
            { value: '+1', label: 'Islas Ultramarinas Menores de Estados Unidos (+1)' },
            { value: '+1 284', label: 'Islas Vírgenes Británicas (+1 284)' },
            { value: '+1 340', label: 'Islas Vírgenes de los Estados Unidos (+1 340)' },
            { value: '+972', label: 'Israel (+972)' },
            { value: '+39', label: 'Italia (+39)' },
            { value: '+1 876', label: 'Jamaica (+1 876)' },
            { value: '+81', label: 'Japón (+81)' },
            { value: '+44', label: 'Jersey (+44)' },
            { value: '+962', label: 'Jordania (+962)' },
            { value: '+7', label: 'Kazajistán (+7)' },
            { value: '+254', label: 'Kenia (+254)' },
            { value: '+996', label: 'Kirgizstán (+996)' },
            { value: '+686', label: 'Kiribati (+686)' },
            { value: '+965', label: 'Kuwait (+965)' },
            { value: '+856', label: 'Laos (+856)' },
            { value: '+266', label: 'Lesoto (+266)' },
            { value: '+371', label: 'Letonia (+371)' },
            { value: '+961', label: 'Líbano (+961)' },
            { value: '+231', label: 'Liberia (+231)' },
            { value: '+218', label: 'Libia (+218)' },
            { value: '+423', label: 'Liechtenstein (+423)' },
            { value: '+370', label: 'Lituania (+370)' },
            { value: '+352', label: 'Luxemburgo (+352)' },
            { value: '+853', label: 'Macao (+853)' },
            { value: '+389', label: 'Macedônia (+389)' },
            { value: '+261', label: 'Madagascar (+261)' },
            { value: '+60', label: 'Malasia (+60)' },
            { value: '+265', label: 'Malawi (+265)' },
            { value: '+223', label: 'Mali (+223)' },
            { value: '+356', label: 'Malta (+356)' },
            { value: '+212', label: 'Marruecos (+212)' },
            { value: '+596', label: 'Martinica (+596)' },
            { value: '+230', label: 'Mauricio (+230)' },
            { value: '+222', label: 'Mauritania (+222)' },
            { value: '+262', label: 'Mayotte (+262)' },
            { value: '+52', label: 'México (+52)' },
            { value: '+691', label: 'Micronesia (+691)' },
            { value: '+373', label: 'Moldavia (+373)' },
            { value: '+377', label: 'Mónaco (+377)' },
            { value: '+976', label: 'Mongolia (+976)' },
            { value: '+382', label: 'Montenegro (+382)' },
            { value: '+1 664', label: 'Montserrat (+1 664)' },
            { value: '+258', label: 'Mozambique (+258)' },
            { value: '+264', label: 'Namibia (+264)' },
            { value: '+674', label: 'Nauru (+674)' },
            { value: '+977', label: 'Nepal (+977)' },
            { value: '+505', label: 'Nicaragua (+505)' },
            { value: '+227', label: 'Niger (+227)' },
            { value: '+234', label: 'Nigeria (+234)' },
            { value: '+683', label: 'Niue (+683)' },
            { value: '+47', label: 'Noruega (+47)' },
            { value: '+687', label: 'Nueva Caledonia (+687)' },
            { value: '+64', label: 'Nueva Zelanda (+64)' },
            { value: '+968', label: 'Omán (+968)' },
            { value: '+31', label: 'Países Bajos (+31)' },
            { value: '+92', label: 'Pakistán (+92)' },
            { value: '+680', label: 'Palau (+680)' },
            { value: '+970', label: 'Palestina (+970)' },
            { value: '+507', label: 'Panamá (+507)' },
            { value: '+675', label: 'Papúa Nueva Guinea (+675)' },
            { value: '+595', label: 'Paraguay (+595)' },
            { value: '+51', label: 'Perú (+51)' },
            { value: '+689', label: 'Polinesia Francesa (+689)' },
            { value: '+48', label: 'Polonia (+48)' },
            { value: '+351', label: 'Portugal (+351)' },
            { value: '+1', label: 'Puerto Rico (+1)' },
            { value: '+974', label: 'Qatar (+974)' },
            { value: '+44', label: 'Reino Unido (+44)' },
            { value: '+236', label: 'República Centroafricana (+236)' },
            { value: '+420', label: 'República Checa (+420)' },
            { value: '+1', label: 'República Dominicana (+1)' },
            { value: '+262', label: 'Reunión (+262)' },
            { value: '+250', label: 'Ruanda (+250)' },
            { value: '+40', label: 'Rumanía (+40)' },
            { value: '+7', label: 'Rusia (+7)' },
            { value: '+212', label: 'Sahara Occidental (+212)' },
            { value: '+685', label: 'Samoa (+685)' },
            { value: '+1 684', label: 'Samoa Americana (+1 684)' },
            { value: '+590', label: 'San Bartolomé (+590)' },
            { value: '+1 869', label: 'San Cristóbal y Nieves (+1 869)' },
            { value: '+378', label: 'San Marino (+378)' },
            { value: '+590', label: 'San Martín (Francia) (+590)' },
            { value: '+508', label: 'San Pedro y Miquelón (+508)' },
            { value: '+1 784', label: 'San Vicente y las Granadinas (+1 784)' },
            { value: '+290', label: 'Santa Elena (+290)' },
            { value: '+1 758', label: 'Santa Lucía (+1 758)' },
            { value: '+239', label: 'Santo Tomé y Príncipe (+239)' },
            { value: '+221', label: 'Senegal (+221)' },
            { value: '+381', label: 'Serbia (+381)' },
            { value: '+248', label: 'Seychelles (+248)' },
            { value: '+232', label: 'Sierra Leona (+232)' },
            { value: '+65', label: 'Singapur (+65)' },
            { value: '+1', label: 'Sint Maarten (+1)' },
            { value: '+963', label: 'Siria (+963)' },
            { value: '+252', label: 'Somalia (+252)' },
            { value: '+94', label: 'Sri lanka (+94)' },
            { value: '+27', label: 'Sudáfrica (+27)' },
            { value: '+249', label: 'Sudán (+249)' },
            { value: '+211', label: 'Sudán del Sur (+211)' },
            { value: '+46', label: 'Suecia (+46)' },
            { value: '+41', label: 'Suiza (+41)' },
            { value: '+597', label: 'Surinám (+597)' },
            { value: '+47', label: 'Svalbard y Jan Mayen (+47)' },
            { value: '+268', label: 'Swazilandia (+268)' },
            { value: '+992', label: 'Tadjikistán (+992)' },
            { value: '+66', label: 'Tailandia (+66)' },
            { value: '+886', label: 'Taiwán (+886)' },
            { value: '+255', label: 'Tanzania (+255)' },
            { value: '+246', label: 'Territorio Británico del Océano Índico (+246)' },
            { value: '+262', label: 'Territorios Australes y Antárticas Franceses (+262)' },
            { value: '+670', label: 'Timor Oriental (+670)' },
            { value: '+228', label: 'Togo (+228)' },
            { value: '+690', label: 'Tokelau (+690)' },
            { value: '+676', label: 'Tonga (+676)' },
            { value: '+1 868', label: 'Trinidad y Tobago (+1 868)' },
            { value: '+216', label: 'Tunez (+216)' },
            { value: '+993', label: 'Turkmenistán (+993)' },
            { value: '+90', label: 'Turquía (+90)' },
            { value: '+688', label: 'Tuvalu (+688)' },
            { value: '+380', label: 'Ucrania (+380)' },
            { value: '+256', label: 'Uganda (+256)' },
            { value: '+598', label: 'Uruguay (+598)' },
            { value: '+998', label: 'Uzbekistán (+998)' },
            { value: '+678', label: 'Vanuatu (+678)' },
            { value: '+58', label: 'Venezuela (+58)' },
            { value: '+84', label: 'Vietnam (+84)' },
            { value: '+681', label: 'Wallis y Futuna (+681)' },
            { value: '+967', label: 'Yemen (+967)' },
            { value: '+253', label: 'Yibuti (+253)' },
            { value: '+260', label: 'Zambia (+260)' },
            { value: '+263', label: 'Zimbabue (+263)' }
        ];
        const dropdowns = document.getElementsByClassName('js-floating-country-code');
        const validateForm = new ValidateFields(this.formState);
        Array.from(dropdowns).forEach(dropdown => {
            const element = dropdown;
            // Evita reconstruir si ya se cargó
            if (element.dataset.loaded === 'true') {
                return;
            }
            element.innerHTML = '';
            phoneCountryCodes.forEach(item => {
                const li = document.createElement('li');
                li.className = 'dropdown-content-item';
                const a = document.createElement('a');
                a.className = 'dropdown-item';
                a.setAttribute('data-indicator', item.value);
                a.setAttribute('href', '#');
                a.textContent = item.label;
                a.addEventListener('click', (event) => {
                    event.preventDefault();
                    validateForm.changeSelectCountryCode(event);
                });
                li.appendChild(a);
                element.appendChild(li);
            });
            element.dataset.loaded = 'true';
        });
    }
}
/**
 * Exports the `GetProjectForm` method, which retrieves the form corresponding to a project.
 */
export { GetProjectForm };
